import { Domain } from '../types/data';
import { supabase } from './supabase';

export const domainService = {
  updateDomain: async (domainId: string, data: Partial<Domain>) => {
    const { data: updatedDomain, error } = await supabase
      .from('domains')
      .update(data)
      .eq('id', domainId);

    if (error) throw error;
    return updatedDomain;
  },
};
